<div class="relative w-full">

  <!-- =========================================================
       HERO
  ========================================================== -->
  <section
    class="relative min-h-[720px] md:min-h-[800px] max-h-[100vh] overflow-hidden bg-bg-base flex items-center antialiased">

    <!-- =======================================================
         BACKGROUND IMAGE
         English  : image remains normal
         Arabic   : image is mirrored
    ======================================================== -->
    <div class="absolute inset-0 z-0 overflow-hidden">

      <img src="hero.png" alt="HomiGo Premium Architecture Showcase" class="
          absolute inset-0
          w-full h-full
          object-cover
          scale-[1.02]
          ltr:scale-x-[1.02]
          rtl:-scale-x-[1.02]
          motion-safe:animate-fade-in
          duration-1000
          select-none
          pointer-events-none
        " />

      <!-- Direction-aware darkness -->
      <div class="
           
        ">
      </div>

      <!-- Additional cinematic bottom gradient -->
      <div class="
          absolute inset-0
          bg-gradient-to-t
          from-black/80
          via-transparent
          to-black/20
          pointer-events-none
        ">
      </div>

      <!-- Subtle brand glow -->
      <div class="
          absolute
          ltr:left-[18%]
          rtl:right-[18%]
          top-1/2
          -translate-y-1/2
          w-[420px]
          h-[420px]
          bg-primary/10
          rounded-full
          blur-[140px]
          pointer-events-none
        ">
      </div>

    </div>


    <!-- =======================================================
         HERO CONTENT
    ======================================================== -->
    <div class="
        relative
        z-10
        w-full
        pt-24
        pb-72
        sm:pt-28
        sm:pb-80
        md:pt-25
        md:pb-52
        lg:pb-40
      " data-aos="fade-down" data-aos-delay="100">

      <div class="container mx-auto px-4 sm:px-6 lg:px-8">

        <div class="
             flex
            flex-col
            items-start
            text-start
          ">

          <!-- =================================================
               BADGE
          ================================================== -->
          <div class="
              inline-flex
              items-center
              gap-2
              px-4
              py-2
              mb-6
              rounded-full
              glass-panel
              border
              border-white/10
              shadow-subtle
              backdrop-blur-md
              hover:border-primary/30
              transition-all
              duration-300
              group
            ">

            <span class="
                flex
                items-center
                justify-center
                w-6
                h-6
                rounded-full
                bg-primary/10
                border
                border-primary/20
              ">
              <i class="
                  fa-solid
                  fa-layer-group
                  text-primary
                  text-[10px]
                  group-hover:scale-110
                  transition-transform
                ">
              </i>
            </span>

            <span class="
                text-[10px]
                sm:text-[11px]
                font-mono
                font-black
                uppercase
                tracking-[0.18em]
                text-text-secondary
              ">
              {{ 'home.header.badge' | translate }}
            </span>

          </div>


          <!-- =================================================
               TITLE
          ================================================== -->
          <div class="space-y-4 mb-8">

            <h1 class="
                text-text-primary
                text-4xl
                sm:text-5xl
                md:text-6xl
                lg:text-7xl
                font-black
                tracking-tight
                leading-[0.98]
                font-mono
                max-w-3xl
              ">
              {{ 'home.header.title' | translate }}
            </h1>

            <h2 class="
                text-text-secondary
                text-lg
                sm:text-xl
                md:text-2xl
                font-medium
                tracking-tight
                max-w-xl
              ">
              {{ 'home.header.subtitle' | translate }}
            </h2>

            <p class="
                text-text-muted
                text-sm
                md:text-base
                leading-relaxed
                font-medium
                max-w-xl
              ">
              {{ 'home.header.searchPlaceholder' | translate }}
            </p>

          </div>


          <!-- =================================================
               BUY / RENT CTA
          ================================================== -->
          <div class="
              flex
              flex-col
              sm:flex-row
              items-stretch
              sm:items-center
              gap-3
              w-full
              sm:w-auto
              mb-8
            ">

            <!-- RENT -->
            <a [routerLink]="['/all-properties']" [queryParams]="{ purpose: 'rent' }" class="
                group
                relative
                btn
                btn-primary
                min-w-[170px]
                py-3.5
                px-6
                text-xs
                font-mono
                font-black
                uppercase
                tracking-wider
                shadow-lg
                shadow-primary/10
                hover:shadow-primary/20
                transition-all
                duration-300
              ">

              <span class="
                  absolute
                  -top-2.5
                  -left-2
                  px-2
                  py-0.5
                  bg-emerald-500
                  text-white
                  text-[8px]
                  font-mono
                  font-black
                  rounded-md
                  shadow-md
                  uppercase
                  tracking-wider
                  flex
                  items-center
                  gap-1
                ">
                <i class="fa-solid fa-bolt-lightning text-[8px]"></i>
                <span>{{ 'home.header.new' | translate }}</span>
              </span>

              <i class="
                  fa-solid
                  fa-key
                  text-xs
                  group-hover:rotate-12
                  transition-transform
                ">
              </i>

              <span>{{ 'home.header.rent' | translate }}</span>

            </a>


            <!-- BUY -->
            <a [routerLink]="['/all-properties']" [queryParams]="{ purpose: 'sale' }" class="
                group
                btn
                btn-secondary
                min-w-[170px]
                py-3.5
                px-6
                text-xs
                font-mono
                font-black
                uppercase
                tracking-wider
                backdrop-blur-md
              ">

              <i class="
                  fa-solid
                  fa-city
                  text-xs
                  group-hover:scale-110
                  transition-transform
                ">
              </i>

              <span>{{ 'home.header.buy' | translate }}</span>

            </a>

          </div>

        </div>

      </div>

    </div>


    <!-- =======================================================
         SEARCH CARD
    ======================================================== -->
    <div class="
        absolute
        z-30
        bottom-6
        sm:bottom-8
        md:bottom-10
        left-1/2
        -translate-x-1/2
        w-[calc(100%-2rem)]
        sm:w-[calc(100%-3rem)]
        lg:w-[calc(100%-4rem)]
        max-w-5xl
      ">

      <div class="
          glass-panel
          rounded-2xl
          md:rounded-3xl
          border
          border-white/10
          bg-black/55
          backdrop-blur-xl
          shadow-2xl
          shadow-black/40
          p-3
          sm:p-4
          md:p-5
        ">

        <!-- ================================================
             SEARCH FORM
        ================================================= -->
        <form (ngSubmit)="onSearch($event)" class="
            flex
            flex-col
            lg:flex-row
            gap-3
            w-full
          ">

          <!-- SEARCH INPUT -->
          <div class="
              relative
              group
              flex-1
            ">

            <div class="
                absolute
                inset-y-0
                start-4
                flex
                items-center
                pointer-events-none
                text-text-muted
                group-focus-within:text-primary
                transition-colors
                z-10
              ">

              <i class="fa-solid fa-magnifying-glass text-sm"></i>

            </div>

            <input type="text" [(ngModel)]="searchQuery" name="search"
              [placeholder]="'home.header.searchInputPlaceholder' | translate"
              (focus)="onFocus()"
              (blur)="onBlur()"
              autocomplete="off"
              class="
                form-input
                w-full
                ps-11
                pe-4
                py-4
                md:py-4.5
                rounded-xl
                bg-white/[0.04]
                border-white/10
                hover:border-white/20
                focus:border-primary/50
                focus:ring-primary/20
                text-text-primary
                placeholder:text-text-muted
                font-medium
                transition-all
                duration-300
              " />

            <!-- SEARCH HISTORY SUGGESTIONS -->
            @if (showHistory && searchHistory.length > 0) {
              <div class="
                  absolute
                  top-[calc(100%+0.5rem)]
                  left-0
                  w-full
                  bg-[#111111]
                  border
                  border-white/10
                  rounded-xl
                  shadow-2xl
                  shadow-black/50
                  z-50
                  overflow-hidden
                ">
                <ul class="py-2">
                  @for (item of searchHistory; track item) {
                    <li>
                      <button type="button" (click)="selectHistoryItem(item)" class="
                          w-full
                          text-start
                          px-4
                          py-3
                          text-sm
                          text-text-secondary
                          hover:text-primary
                          hover:bg-white/[0.03]
                          transition-colors
                          flex
                          items-center
                          gap-3
                        ">
                        <i class="fa-solid fa-clock-rotate-left text-xs opacity-50"></i>
                        <span>{{ item }}</span>
                      </button>
                    </li>
                  }
                </ul>
              </div>
            }

          </div>


          <!-- SEARCH BUTTON -->
          <button type="submit" class="
              group
              btn
              btn-primary
              min-h-[52px]
              lg:min-w-[180px]
              px-7
              rounded-xl
              text-xs
              font-mono
              font-black
              uppercase
              tracking-wider
              shadow-lg
              shadow-primary/10
              hover:shadow-primary/25
              transition-all
              duration-300
            ">

            <i class="
                fa-solid
                fa-map-location-dot
                text-xs
                text-white/80
                group-hover:scale-110
                transition-transform
              ">
            </i>

            <span>
              {{ 'home.header.searchButton' | translate }}
            </span>

            <i class="
                fa-solid
                rtl:fa-arrow-left
                ltr:fa-arrow-right
                text-[10px]
                mx-1
                group-hover:translate-x-0.5
                rtl:group-hover:-translate-x-0.5
                transition-transform
              ">
            </i>

          </button>

        </form>


        <!-- ================================================
             QUICK SEARCH
        ================================================= -->
        <!-- <div class="
            mt-3
            pt-3
            md:pt-4
            border-t
            border-white/[0.07]
            flex
            flex-col
            lg:flex-row
            lg:items-center
            gap-3
          ">

           <div class="
              flex
              items-center
              gap-2
              shrink-0
            ">

            <span class="
                flex
                items-center
                justify-center
                w-7
                h-7
                rounded-lg
                bg-primary/10
                border
                border-primary/10
              ">
              <i class="
                  fa-solid
                  fa-fire
                  text-primary
                  text-[10px]
                ">
              </i>
            </span>

            <span class="
                text-text-secondary
                text-[10px]
                sm:text-[11px]
                uppercase
                tracking-[0.12em]
                font-mono
                font-black
              ">
              {{ 'home.header.quickSearch' | translate }}
            </span>

          </div>


           <div class="
              flex
              flex-wrap
              items-center
              gap-2
              w-full
            ">

             <button #furnishedBtn type="button" (click)="quickSearch(furnishedBtn.textContent.trim())" class="
                group
                inline-flex
                items-center
                gap-2
                px-3.5
                py-2.5
                rounded-lg
                bg-white/[0.035]
                hover:bg-primary/[0.08]
                border
                border-white/[0.07]
                hover:border-primary/30
                text-text-secondary
                hover:text-text-primary
                transition-all
                duration-200
                text-[10px]
                sm:text-[11px]
                font-semibold
              ">

              <i class="
                  fa-solid
                  fa-couch
                  text-[10px]
                  text-text-muted
                  group-hover:text-primary
                  transition-colors
                ">
              </i>

              <span>
                {{ quickSearchKeys.furnished | translate }}
              </span>

            </button>


             <button #studioBtn type="button" (click)="quickSearch(studioBtn.textContent.trim())" class="
                group
                inline-flex
                items-center
                gap-2
                px-3.5
                py-2.5
                rounded-lg
                bg-white/[0.035]
                hover:bg-primary/[0.08]
                border
                border-white/[0.07]
                hover:border-primary/30
                text-text-secondary
                hover:text-text-primary
                transition-all
                duration-200
                text-[10px]
                sm:text-[11px]
                font-semibold
              ">

              <i class="
                  fa-solid
                  fa-wand-magic-sparkles
                  text-[10px]
                  text-text-muted
                  group-hover:text-primary
                  transition-colors
                ">
              </i>

              <span>
                {{ quickSearchKeys.studio | translate }}
              </span>

            </button>


             <button #chaletBtn type="button" (click)="quickSearch(chaletBtn.textContent.trim())" class="
                group
                inline-flex
                items-center
                gap-2
                px-3.5
                py-2.5
                rounded-lg
                bg-white/[0.035]
                hover:bg-primary/[0.08]
                border
                border-white/[0.07]
                hover:border-primary/30
                text-text-secondary
                hover:text-text-primary
                transition-all
                duration-200
                text-[10px]
                sm:text-[11px]
                font-semibold
              ">

              <i class="
                  fa-solid
                  fa-umbrella-beach
                  text-[10px]
                  text-text-muted
                  group-hover:text-primary
                  transition-colors
                ">
              </i>

              <span>
                {{ quickSearchKeys.chalet | translate }}
              </span>

            </button>

          </div>

        </div> -->

      </div>

    </div>

  </section>

</div>